import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Grid,
  Paper,
  TextField,
  Typography,
  MenuItem,
} from "@mui/material";
import { getCar, updateCar } from "../../api/car";
import { listDevices } from "../../api/device";
import { uploadFile } from "../../api/file";
import { Car, Device } from "../../types/api";
import { Save } from "@mui/icons-material";

const prefixes = ["นาย", "นาง", "นางสาว"];

export default function CarEditPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [car, setCar] = useState<Car | null>(null);
  const [devices, setDevices] = useState<Device[]>([]);
  const [preview, setPreview] = useState<string>("");
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const load = async () => {
    if (!id) return;

    const data = await getCar(Number(id));
    setCar(data);
    setPreview(data.imagePath || "");

    const { list } = await listDevices();

    // ✅ กรองเฉพาะอุปกรณ์ที่ยังไม่ถูกผูก หรือเป็นของรถคันนี้เอง
    const filtered = list.filter(
      (d: any) => !d.carId || d.carId === data.id
    );

    setDevices(filtered);
  };

  useEffect(() => {
    load();
  }, [id]);


  const handleChange = (field: keyof Car, value: any) => {
    setCar((prev) => (prev ? { ...prev, [field]: value } : prev));
  };

  const handleSelectFile = (file: File) => {
    setSelectedFile(file);
    setPreview(URL.createObjectURL(file));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!car || !id) return;

    try {
      let imageUrl = car.imagePath;

      // ✅ upload เฉพาะตอนกด save
      if (selectedFile) {
        const url = await uploadFile(selectedFile);
        imageUrl = url;
      }

      const payload = { ...car, imagePath: imageUrl };
      await updateCar(Number(id), payload);
      navigate("/cars");
    } catch (err) {
      console.error("Save failed:", err);
    }
  };

  if (!car) return <Typography>กำลังโหลด...</Typography>;

  return (
    <Box>
      <Typography variant="h6" mb={2}>
        แก้ไขข้อมูลรถ
      </Typography>
      <Paper sx={{ p: 3 }}>
        <Box component="form" onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid size={6}>
              <TextField
                fullWidth
                label="หมายเลขรถ / เลขทะเบียนรถ"
                value={car.plateNumber || ""}
                onChange={(e) => handleChange("plateNumber", e.target.value)}
              />
            </Grid>
            <Grid size={6}>
              <TextField
                fullWidth
                select
                label="GPS Device (Box Id)"
                value={car.deviceId || ""}
                onChange={(e) => handleChange("deviceId", Number(e.target.value))}
              >
                <MenuItem value="">-- เลือก GPS --</MenuItem>
                {devices.map((d : any) => (
                  <MenuItem key={d.id} value={d.id}>
                    {d.boxId}
                    {d.simNumber ? ` (${d.simNumber})` : ""}
                  </MenuItem>
                ))}
              </TextField>

            </Grid>

            <Grid size={2}>
              <TextField
                fullWidth
                select
                label="คำนำหน้า"
                value={car.prefix || ""}
                onChange={(e) => handleChange("prefix", e.target.value)}
              >
                {prefixes.map((p) => (
                  <MenuItem key={p} value={p}>
                    {p}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid size={5}>
              <TextField
                fullWidth
                label="ชื่อ"
                value={car.firstName || ""}
                onChange={(e) => handleChange("firstName", e.target.value)}
              />
            </Grid>

            <Grid size={5}>
              <TextField
                fullWidth
                label="นามสกุล"
                value={car.lastName || ""}
                onChange={(e) => handleChange("lastName", e.target.value)}
              />
            </Grid>

            {/* ✅ Upload Zone */}
            {/* <Grid size={12}>
              <Box
                onDragOver={(e) => e.preventDefault()}
                onDrop={(e) => {
                  e.preventDefault();
                  const file = e.dataTransfer.files?.[0];
                  if (file) handleSelectFile(file);
                }}
                onClick={() =>
                  document.getElementById("image-upload-input")?.click()
                }
                sx={{
                  border: "2px dashed #bbb",
                  borderRadius: 2,
                  textAlign: "center",
                  py: 4,
                  cursor: "pointer",
                  backgroundColor: "#fafafa",
                  "&:hover": { backgroundColor: "#fffde7" },
                }}
              >
                {preview ? (
                  <Box
                    component="img"
                    src={preview}
                    alt="preview"
                    sx={{
                      width: 160,
                      height: 160,
                      borderRadius: 2,
                      objectFit: "cover",
                      border: "1px solid #ccc",
                    }}
                  />
                ) : (
                  <>
                    <Typography variant="body1" color="text.secondary">
                      คลิกหรือลากรูปมาวางที่นี่
                    </Typography>
                    <Typography variant="body2" color="text.disabled">
                      รองรับไฟล์ .jpg, .png
                    </Typography>
                  </>
                )}
                <input
                  id="image-upload-input"
                  type="file"
                  accept="image/*"
                  hidden
                  onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (file) handleSelectFile(file);
                  }}
                />
              </Box>
            </Grid> */}

            <Grid size={12} display="flex" justifyContent="flex-end">
              <Button
                type="submit"
                variant="contained"
                startIcon={<Save />}
                sx={{
                  backgroundColor: "#FEDC00",
                  color: "#000",
                  "&:hover": {
                    backgroundColor: "#FBC02D",
                    color: "#222",
                  },
                  mt: 2,
                }}
              >
                บันทึก
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Box>
  );
}
